import { useState } from "react";
import useClippy from "use-clippy";

export default function useClipboard() {

    const [clipboard, setClipboard] = useClippy();

    // Check if clipboard API is available in the browser
    const hasClipboard = 'clipboard' in window.navigator;
    if (!hasClipboard) throw new Error('Browser does not support clipboard manipulations');

    const hasFocus = document.hasFocus();
    if (!hasFocus) return '';

    // Request Permission to use the clipboard API. 
    navigator.permissions.query({name: "clipboard-read"} as any).then(result => {
        // If permission to read the clipboard is granted or if the user will
        // be prompted to allow it, we proceed.

        if (result.state === "granted" || result.state === "prompt") {
            navigator.clipboard.readText().then(data => {
                // console.log(data)
                setClipboard(data)
            });
        }
    });

    return clipboard;
}